import { useMemo } from 'react';

import {
  useEntitySchema,
  useRouteAndQueryParams,
} from '@april9au/stack9-react';
import { ColumnConfigurationRenderAs, ep, ern } from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

import { ListTable } from '../../components/ListTable/ListTable';
import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';
import ApplicationForm from './ApplicationForm';
import StaffBreakdownForm from './StaffBreakdownForm';

const S9CustomEntityFormPage = ui.S9CustomEntityFormPage.default;
const S9Tabs = ui.S9Tabs.default;

const Index = () => {
  const { schema } = useEntitySchema(entityNames.APPLICATION);

  const {
    routeParams: { id = '' },
  } = useRouteAndQueryParams();

  const applicationId = ern(+ep(id));

  const items = useMemo(
    () => [
      {
        label: 'Details',
        key: 'details',
        children: <ApplicationForm schema={schema} />,
      },
      {
        label: 'Staff breakdown',
        key: 'staff_breakdown',
        children: (
          <StaffBreakdownForm schema={schema} applicationId={applicationId} />
        ),
      },
      {
        label: 'Response',
        key: 'response',
        children: (
          <ListTable
            searchFields={[
              'id',
              'requirement_code',
              'section_code',
              'response_option',
              'response_text',
              'status',
              'assessor_comment',
            ]}
            showFilter
            columns={[
              {
                label: 'ID',
                value: '{{id}}',
                field: 'id',
                renderAs: ColumnConfigurationRenderAs.CustomComponent,
                options: {
                  customComponentName: 'ApplicationResponseAction',
                },
              },
              {
                label: 'Requirement code',
                value: '{{requirement_code}}',
                field: 'requirement_code',
                renderAs: ColumnConfigurationRenderAs.Text,
              },
              {
                label: 'Section code',
                renderAs: ColumnConfigurationRenderAs.Text,
                value: '{{section_code}}',
                field: 'section_code',
              },
              {
                label: 'Response option',
                renderAs: ColumnConfigurationRenderAs.Text,
                value: '{{response_option}}',
                field: 'response_option',
              },
              {
                label: 'Response text',
                value: '{{response_text}}',
                field: 'response_text',
                renderAs: ColumnConfigurationRenderAs.Text,
              },
              {
                label: 'Status',
                renderAs: ColumnConfigurationRenderAs.Text,
                value: '{{status}}',
                field: 'status',
              },
              {
                label: 'Assessor comment',
                renderAs: ColumnConfigurationRenderAs.Text,
                value: '{{assessor_comment}}',
                field: 'assessor_comment',
              },
            ]}
            queryName="getresponsebyapplication"
            queryVars={{
              applicationId,
            }}
            title="Response"
          />
        ),
      },
      {
        label: 'Survey',
        key: 'survey',
        children: (
          <ListTable
            columns={[
              {
                label: 'Survey question',
                field: 'code',
                value: '{{code}}',
                renderAs: ColumnConfigurationRenderAs.Text,
              },
              {
                label: 'Response',
                field: 'response',
                value: '{{response}}',
                renderAs: ColumnConfigurationRenderAs.Text,
              },
            ]}
            queryName="getsurveybyapplication"
            queryVars={{
              applicationId,
            }}
            title="Survey"
          />
        ),
      },
    ],
    [applicationId, schema],
  );
  return (
    <S9CustomEntityFormPage
      entityKey={entityNames.APPLICATION}
      screenQueryName={EDetailsQueryNames.GetApplicationDetails}
      entityId={applicationId}
      title={data => `Application #${data?.id}`}
      cancelLink={AppRoutes.ApplicationList}
    >
      <S9Tabs items={items} />
    </S9CustomEntityFormPage>
  );
};
export default Index;
